import { render, staticRenderFns } from "./AddressTabs.vue?vue&type=template&id=d21fb604"
import script from "./AddressTabs.vue?vue&type=script&lang=js"
export * from "./AddressTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports